<template>
    <div class="rent-page">
        <div class="public-banner bg-cover">
            <div class="absolute center text-center color-white">
                <h1>租赁中心</h1>
                <p class="English">Product Center</p>
            </div>
        </div>
        <div class="process-part">
            <div class="container">
                <h3>为什么选择租？</h3>
                <h2>以租代买 租享更尽兴</h2>
                <ul class="reason-list display-flex-between">
                    <li>
                       <img class="image" src="https://resource.tanwuapp.com/FofRGq07nMR_6trbuJSjXFr6z_T5">
                       <p class="tip">更划算</p>
                       <p class="content">数码设备费用昂贵且使用频次很低，大部分人购买后是处于闲置状态。现在通过以租代买，只需为使用付费，不为闲置买单</p>
                    </li>
                    <li>
                       <img class="image" src="https://resource.tanwuapp.com/FrrFMe3_PHv4BRHKrYS3IMo5robb">
                       <p class="tip">更丰富</p>
                       <p class="content">探物与众多一线品牌合作，为用户提供的产品囊括了相机、镜头、无人机、游戏、VR、影音、显卡等丰富的数码品类</p>
                    </li>
                    <li>
                       <img class="image" src="https://resource.tanwuapp.com/Fr89nAXr72OEML55yTfmzvnzLqzV">
                       <p class="tip">更新奇</p>
                       <p class="content">探物采购部时刻关注科技数码市场产品动态，用专业的评测为用户挑选好玩、好用、新奇的科技数码产品</p>
                    </li>
                </ul>
                <h3>怎么开始租？</h3>
                <h2>流畅的租赁服务体验</h2>
                <div class="step-wrap" id="lineBox">
                    <div class="content absolute left top right bottom">
                        <div class="words-item display-flex-between flex-align-start">
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/FtAudcF_WxrhSNamM1ZhSo_WPMPk">
                                <p class="title">选择产品下单</p>
                                <p class="desc">选定产品的租期，支付租金<br/>押金（多种方式可信用免押金）</p>
                            </div>
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/FlxFIfcHrxBcduTiX5Koi6vsEbA0">
                                <p class="title">仓库发货</p>
                                <p class="desc">付款成功后订单进入风控审核<br/>仓库发货部准备发货</p>
                            </div>
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/Foc1KUMx1ARESd0qhlbENhDO_3EH">
                                <p class="title">收货体验</p>
                                <p class="desc">用户收货后检查设备是否完好<br/>即可开始享受租赁体验</p>
                            </div>
                        </div>
                        <div class="words-item display-flex-between flex-align-start">
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/FnO4E2t4AsT8Aouw1mZGwyhzUVxs">
                                <p class="title">清洁返库</p>
                                <p class="desc">设备需经过标准清洁消毒后<br/>返回仓库等待用户下次租用</p>
                            </div>
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/FkWzZS26OZHCnxvczPgrypPrm-kR">
                                <p class="title">检货退押</p>
                                <p class="desc">仓库收货部收货后检测设备无误<br/>3-5个工作日退还押金（节假日顺延）</p>
                            </div>
                            <div class="item">
                                <img src="https://resource.tanwuapp.com/Fgv2J6hTZZZeISWoOJrcQ_ZJR5l1">
                                <p class="title">到期归还/买断</p>
                                <p class="desc">到期后用户可选择归还或买断产品<br/>来回双程均使用顺丰快递，安全有保障</p>
                            </div>
                        </div>
                    </div>
                    <div class="line-box flex flex-column" >
                        <div class="flex">
                            <div class="line-wrap">
                                <span class = "bg bg0"></span>
                                <span class = "line line0"></span>
                            </div>
                            <div class="mask-wrap">
                                <span class = "mask-bg mask-bg0"></span>
                                <div class="mask mask0">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                        <div class="vertical-wrap">
                            <span class="bg"></span>
                            <span class="vertical-line"></span>
                        </div>
                        <div class="flex">
                            <div class="line-wrap">
                                <span class = "bg bg1"></span>
                                <span class = "line line1"></span>
                            </div>
                            <div class="mask-wrap">
                                <span class = "mask-bg mask-bg1"></span>
                                <div class="mask mask1">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                        <span class="point-wrap"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-part">
            <div class="container">
                <p class="part-title">租赁产品</p>
                <rentBox></rentBox>
            </div>
        </div>
        <div class="scene-part">
            <div class="container">
                <p class="part-title">租赁场景</p>
                <sceneBox></sceneBox>
            </div>
        </div>
        <div class="comment-part">
            <div class="container">
                <p class="part-title">与数百万数码爱好者<br/>一起开启租享新生活一起开启</p>
                <swiper class = "swiper" :options="swiperOptionPartner">
                    <swiper-slide>
                        <ul class="comment-list display-flex-between">
                            <li v-for="item in commentList" class="display-flex-between flex-column">
                                <p class="content">{{item.content}}</p>
                                <div class="info display-flex-between flex-align-center">
                                    <div class="flex flex-align-center">
                                        <span class="avatar bg-cover" :style="{'background-image':'url('+item.avatar+')'}"></span>
                                        <span class="name">{{item.name}}</span>
                                    </div>
                                    <div class="flex">
                                        <span v-for="item2 in item.tags" class="tag">#{{item2}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
	import Vue from 'vue'
    import { CONFIG,network } from '@assets/js/apis';
    import rentBox from '@components/rentBox';
    import sceneBox from '@components/sceneBox';
    import 'swiper/dist/css/swiper.css';
    import { swiper, swiperSlide } from 'vue-awesome-swiper';
    export default {
		data() {
			return {
                swiperOptionPartner:{
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    disableOnInteraction: false
                },
                commentList:[
                    {
                        avatar:'https://resource.tanwuapp.com/FsTxSlkV0vBV1d9DcvcDFiNiFhv6',
                        name:'TW2108***547',
                        content:'我每年都会出国游玩4-6次左右，出发前会在探物租上不同的设备，运动相机、潜水相机、无人机、还有必备的翻译机都是我经常租的，每次花200来块钱就可以使用到好品牌的设备，真的是超划算！',
                        tags:['旅游达人']
                    },
                    {
                        avatar:'https://resource.tanwuapp.com/FoKQFtCeBFSOA3i46p3d4VrAz3sY',
                        name:'TW1822***712',
                        content:'我刚刚创业初期，资金比较紧张，通过在探物租赁电脑和测试机，解决了公司起步时资金紧缺一个大难题，让我可以花很少的钱，获得到高品质有保障的服务。',
                        tags:['初创公司','企业租']
                    },
                    {
                        avatar:'https://resource.tanwuapp.com/FuFz0aEUoCrj4TPlDKNiFqOm3wbf',
                        name:'TW2482***211',
                        content:'对于我这样的UP主，经常需要对新发布的数码设备进行测评。探物租赁的数码产品品类齐全、新品上架速度快，花很少的钱久可以拥有一个高品质的数码产品库。这种体验真的太赞啦～',
                        tags:['自媒体','产品评测']
                    },
                    {
                        avatar:'https://resource.tanwuapp.com/FuFH6pEUWKZGtVR5e5nwqlDJ1UOe',
                        name:'TW2273***473',
                        content:'我在探物租了台无人机，航拍了一段户外风景，每没想到在抖音上爆啦！！！新奇的视觉画面会更受欢迎，所以我还会在探物租赁运动相机、潜水相机，拍摄一些更加独特的画面。',
                        tags:['短视频达人']
                    },
                    {
                        avatar:'https://resource.tanwuapp.com/FtK8IoLUuocuPiAulTbOjje6MFY_',
                        name:'TW1483***183',
                        content:'每年只要apple手机、电脑出了新品，像我这种喜新厌旧的果粉，就会更换成最新款，通过以租代买这种新的模式，可以花低价钱满足我的需求。',
                        tags:['90后','白领']
                    },
                    {
                        avatar:'https://resource.tanwuapp.com/FmX1SnVtDqfiU1MwMzywA_owZyza',
                        name:'TW1272***389',
                        content:'学校摄影课要求我们自带相机学习，可相机最少都得花好几千，贵的上万元，我们根本买不起。现在可以通过租的方式，花上几百块钱就可以使用一段时间，对我们大学生真的太友好啦～',
                        tags:['大学生','摄影爱好者']
                    },
                ]
			}
        },
        components: {
            swiper,
            swiperSlide,
            rentBox,
            sceneBox
		},
        created(){
        },
        mounted() {
           window.addEventListener('scroll', this.pageScroll);
        },
        destroyed() {
			window.removeEventListener('scroll', this.pageScroll)
		},
        methods:{
            pageScroll(){
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
                let $lineBox = document.getElementById('lineBox');
                if($lineBox){
                    const $lines = document.querySelectorAll('.line');
                    const $masks = document.querySelectorAll('.mask');
                    const $vertical = document.querySelector('.vertical-line');
                    const $point = document.querySelector('.point-wrap');
                    let offsetTop = $lineBox.offsetTop;
                    let start = 350;
                    let i = 50,i2 = 150;
                    if(scrollTop + windowHeight < offsetTop+start){
                        for(let j = 0;j < 2 ; j++){
                            $lines[j].style.width = 0;
                            $masks[j].style.height = 0;
                        }
                        $vertical.style.height = 0;
                        $point.classList.remove('active');
                    }
                    // else if(scrollTop + windowHeight > offsetTop+800){
                    //     for(let j = 0;j < 2 ; j++){
                    //         $lines[j].style.width = '100%';
                    //         $masks[j].style.height = '100%';
                    //         $vertical.style.height = '100%';
                    //         $point.classList.add('active');
                    //     }
                    // }
                    else{
                        let diff = scrollTop + windowHeight - offsetTop - start;
                        if(diff < i2){
                            $lines[0].style.width = diff/i2 * 100 + '%';
                            $masks[0].style.height = 0;
                            $vertical.style.height = 0;
                            $masks[1].style.height = 0;
                            $lines[1].style.width = 0;
                            $point.classList.remove('active');
                        }else if(diff < i * 1 + i2 * 1){
                            $lines[0].style.width = '100%';
                            $masks[0].style.height = (diff - i2 * 1)/i * 100 + '%';
                            $vertical.style.height = 0;
                            $masks[1].style.height = 0;
                            $lines[1].style.width = 0;
                            $point.classList.remove('active');
                        }else if(diff < i * 2 + i2 * 1){
                            $lines[0].style.width = '100%';
                            $masks[0].style.height = '100%';
                            $vertical.style.height = (diff - i * 1 - i2 * 1)/i * 100 + '%';
                            $masks[1].style.height = 0;
                            $lines[1].style.width = 0;
                            $point.classList.remove('active');
                        }else if(diff < i * 2 + i2 * 2){
                            $lines[0].style.width = '100%';
                            $masks[0].style.height = '100%';
                            $vertical.style.height = '100%';
                            $masks[1].style.height = (diff - i * 2 - i2 * 1)/i2 * 100 + '%';
                            $lines[1].style.width = 0;
                            $point.classList.remove('active');
                        }else if(diff < i * 3 + i2 * 2){
                            $lines[0].style.width = '100%';
                            $masks[0].style.height = '100%';
                            $vertical.style.height = '100%';
                            $masks[1].style.height = '100%';
                            $lines[1].style.width = (diff  - i * 2 - i2 * 2)/i * 100 + '%';
                            $point.classList.remove('active');
                        }else{
                            $lines[0].style.width = '100%';
                            $masks[0].style.height = '100%';
                            $vertical.style.height = '100%';
                            $masks[1].style.height = '100%';
                            $lines[1].style.width = "100%";
                            $point.classList.add('active');
                        }
                    }

                }
			}
        }
    }
</script>

<style lang="scss">
    .rent-page {
        .public-banner{
            background-image:url('https://resource.tanwuapp.com/Ft2QO74gd-y1Uq7eayD-g7_iBGPk') ;
        }
        .part-title{
            padding: 50px 0 30px;
            text-align: center;
            font-size: 32px;
            font-weight: bold;
        }
        .process-part{
            text-align: center;
            padding-bottom: 100px;
            h3{
                color: #666666;
                font-weight: normal;
                padding-top: 50px;
                padding-bottom: 12px;
                line-height: 1.375;
            }
            h2{
                font-size: 32px;
                line-height: 1.4;
                letter-spacing: 1px;
            }
            .reason-list{
                margin-top: 30px;
                li{
                    width: 28.33333%;
                    .image{
                        width: 220px;
                        margin: auto;
                    }
                    .tip{
                        margin-top: 23px;
                        margin-bottom: 15px;
                        line-height: 1.3888888;
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .content{
                        line-height: 1.625;
                        height: 125px;
                    }
                }
            }
        }
        .product-part{
            padding-bottom: 80px;
            background: #F5F6FA;
            overflow: hidden;
        }
        .scene-part{
            padding-bottom: 100px;
        }
        .comment-part{
            padding-bottom: 80px;
            background: #F5F6FA;
            .part-title{
                padding: 80px 0 60px;
            }
            .swiper{
                padding-bottom: 60px;
            }
            .comment-list{
                flex-wrap: wrap;
                li{
                    box-sizing: border-box;
                    width: 32.1666%;
                    padding: 29px 30px 20px;
                    background: #ffffff url(~@assets/img/two-line.png) no-repeat;
                    background-size: 20px auto;
                    background-position: 14px 13px;
                    &:nth-child(-n+3){
                        margin-bottom: 20px;
                    }
                    .content{
                        color: #333333;
                        line-height: 1.5;
                        min-height: 133px;
                        @media only screen and (max-width: 1100px) {
                            font-size: 14px;
                        }
                    }
                    .info{
                        flex-wrap: wrap;
                        .avatar{
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                        .name{
                            font-size: 14px;
                        }
                        .tag{
                            font-size: 14px;
                            color: #999999;
                            & +.tag{
                                margin-left: 16px;
                            }
                        }
                    }
                    
                }
            }
        }
        .step-wrap{
            position: relative;
            margin-top: 43px;
            padding-top: 100px;
            padding-bottom: 80px;
            .content{
                .words-item{
                }
                .item{
                    width: 29.16666%;
                    text-align: center;
                    font-size: 14px;
                    img{
                        height: 100px;
                        width: 100px;
                    }
                    .title{
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 25px;
                        margin-top: 27px;
                        margin-bottom: 5px;
                    }
                    .desc{
                        display: inline-block;
                        max-width: 240px;
                        height: 130px;
                        line-height: 22px;
                    }
                }
            }
            .line-box{
                position: relative;
                // height:294px;
                margin-right: -40px;
                @media only screen and (max-width: 1400px) {
                    margin-right: -20px;
                }
                .point-wrap{
                    position: absolute;
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    border: 7px solid #DDDDDD;
                    box-sizing: border-box;
                    background: #ffffff;
                    bottom: -8px;
                    left: 0;
                    transition: all 0.1s;
                    &.active{
                        border-color: #3ED8C4;
                    }
                }
                .mask-wrap{
                    position: relative;
                    height: 108px;
                    width: 108px;
                    .mask{
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 0;
                        overflow: hidden;
                    }
                    .mask > span , .mask-bg{
                        display: block;
                        box-sizing: border-box;
                        width: 100%;
                        height: 108px;
                    }
                    .mask0 > span,.mask-bg0{
                        border-top-right-radius:100%;
                        border-top: 7px solid #3ED8C4;
                        border-right: 7px solid #3ED8C4;
                    }
                    .mask1 > span,.mask-bg1{
                        border-bottom-right-radius:100%;
                        border-bottom: 7px solid #3ED8C4;
                        border-right: 7px solid #3ED8C4;
                    }
                    .mask-bg0 ,.mask-bg1{
                        border-color: #DDDDDD;
                    }
                }
                .line-wrap{
                    position: relative;
                    width: 0;
                    flex: 1;
                    .line,.bg{
                        position: absolute;
                        width: 0;
                        display:block;
                        height: 7px;
                        background: #3ED8C4;
                    }
                    .bg{
                        background: #DDDDDD;
                        width: 100%;
                    }
                    .line0,.bg0{
                        top: 0;
                        left: 0;
                        border-top-left-radius: 4px;
                        border-bottom-left-radius: 4px;
                    }
                    .line1,.bg1{
                        bottom: 0;
                        right: 0;
                    }
                }
                .vertical-wrap{
                    position: relative;
                    height: 81px;
                    .vertical-line,.bg{
                        position: absolute;
                        display:block;
                        top: 0;
                        right: 0;
                        height: 0;
                        width: 7px;
                        background: #3ED8C4;
                    }
                    .bg{
                        background: #DDDDDD;
                        height:100%;
                    }
                }
            }
        }
        
    }
</style>



// WEBPACK FOOTER //
// src/pages/content/children/rent.vue